<template>
  <div class="container-fluid mt-3">
    <div class="row justify-content-center">
      <div class="col-xl-6">
        <b-card no-body>
          <b-card-header header-tag="nav">
            <b-nav card-header tabs>
              <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
              <b-nav-item :to="linkToProjects" exact exact-active-class="active">Projects</b-nav-item>
              <b-nav-item :to="linkToUsers" exact exact-active-class="active">Users</b-nav-item>
              <b-nav-item :to="linkToInvites" exact exact-active-class="active">Invites</b-nav-item>

<!--              TODO: add apps tab -->

<!--              TODO: add billing tab -->

<!--              TODO: uncomment storage tab -->
<!--              <b-nav-item :to="linkToStorage" exact exact-active-class="active">Storage</b-nav-item>-->

            </b-nav>
          </b-card-header>

          <b-card-body>
            <!-- child nav route renders here -->
            <router-view></router-view>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  computed: {
    workspaceId() {
      return this.$route.params.workspaceId;
    },
    linkToProjects() {
      return `/workspace/${this.workspaceId}/projects`;
    },
    linkToUsers() {
      return `/workspace/${this.workspaceId}/users`;
    },
    linkToStorage() {
      return `/workspace/${this.workspaceId}/storage`;
    },
    linkToInvites() {
      return `/workspace/${this.workspaceId}/invites`;
    },
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
